// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2QKEU","notes":"Notes_notes__3CcdW","note":"Notes_note__2omGb","markdown":"Notes_markdown__2Vt19"};